// extracted by mini-css-extract-plugin
export default {"container":"EnvironmentalPolicyPage_container__pgOJC"};